import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=49c7cef4&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/l-setting-for-configuration-tool/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49c7cef4')) {
      api.createRecord('49c7cef4', component.options)
    } else {
      api.reload('49c7cef4', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=49c7cef4&", function () {
      api.rerender('49c7cef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Views/Settings.vue"
export default component.exports